import React from "react";
import { Helmet } from "react-helmet-async";

export const Register = () => {
  return (
    <>
      <Helmet>
        <title>Регистрация | HajjTravel.kz</title>
        <meta name="description" content="Оқу платформасына тіркелу" />
      </Helmet>
      <div>Register</div>
    </>
  );
};
